import React,{useEffect} from 'react';
import * as actions from '../Actions'

export default function ({ highlightsfeed, eleRef }) {
    useEffect(() => {
        if(highlightsfeed.data.length > 0){
            eleRef.getPeriodDate();
        }
           
    });    
    return (
        <div>
        {highlightsfeed.data.length > 0 ? 
    <section className="main_container_block_feeds">
          <div className="main_block_container_feed">
               <div className="block_container_feed_heading_text R15_61" role='heading' tabIndex={0} aria-label={highlightsfeed.title}>
               {highlightsfeed.title?highlightsfeed.title:''}
                </div>
                <div className="content-div-box-artical">
                   <div className="fertil_background_main_view">
                   <div className="period_Ovulation_background_pic" style={{background:'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/period_&_ovlation_tracker.webp'}}>                           <div className="ovulation_Days_calculator">
                                <div className="ovulation_Days_cal_view weekly_padding-y mr_b10"> 
                                  <div className="my_custom_calendar_range"> 
                                      <div className="weekdays_calendar_range">
                                         <div className="week_days_range_t"> Mo</div>
                                         <div className="week_days_range_t"> Tu </div>
                                         <div className="week_days_range_t"> We </div>
                                         <div className="week_days_range_t"> Th </div>
                                         <div className="week_days_range_t"> Fr </div>
                                         <div className="week_days_range_t"> Sa </div>
                                         <div className="week_days_range_t"> Su </div>
                                       </div>
                                       <div className="weekdays_range_number">
                                        <div className="calendar-week">
                                           
                                         </div>
                                       </div>
                                   </div>
                                  
                                </div> 
                                 <div className="period_ovulation_Days_cal_view fc_mr_b20"> 
                                    <div className="period_ovulation_Days_common">
                                       <div className="left_ovulation"> 
                                          <span className="expcting_period_left"> <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Expected.svg" alt="Expecting Period" title='Expecting Period'/> </span>
                                          <span className="expcting_period_text_right R13_21"> Expecting Period : </span>
                                       </div> 
                                        <div className="right_ovulation M14_21">  {highlightsfeed.data[0].expStartDate ? actions.formatArticleDate(highlightsfeed.data[0].expStartDate): ''} - {highlightsfeed.data[0].expStartDate ? actions.formatArticleDate(highlightsfeed.data[0].expEndDate): ''}</div> 
                                    </div>
                                    <div className="period_ovulation_Days_common">
                                       <div className="left_ovulation"> 
                                          <span className="expcting_period_left"> <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Fertile.svg" alt="Fertile Period" title='Fertile Period'/> </span>
                                          <span className="expcting_period_text_right R13_21"> Fertile Period : </span>
                                       </div> 
                                       <div className="right_ovulation M14_21">   {highlightsfeed.data[0].expFertileStartDate ? actions.formatArticleDate(highlightsfeed.data[0].expFertileStartDate): ''} - {highlightsfeed.data[0].expFertileEndDate ? actions.formatArticleDate(highlightsfeed.data[0].expFertileEndDate): ''} </div> 
                                    </div>
                                    <div className="period_ovulation_Days_common">
                                       <div className="left_ovulation"> 
                                          <span className="expcting_period_left"> <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Ovulation.svg" alt="Ovulation Period" title='Ovulation Period'/> </span>
                                          <span className="expcting_period_text_right R13_21"> Ovulation Period : </span>
                                       </div> 
                                       <div className="right_ovulation M14_21">   {highlightsfeed.data[0].expOvulationDay ? actions.formatArticleDate(highlightsfeed.data[0].expOvulationDay): ''} - {highlightsfeed.data[0].lastovulationDay ? actions.formatArticleDate(highlightsfeed.data[0].lastovulationDay): ''} </div> 
                                    </div>
                                </div>
                                <div className="ovulation_fertic_btn_group_join_common  fc_mr-b10">
                                <a href={(highlightsfeed.dataApp)?highlightsfeed.dataApp[0].redirectionUrl:'https://parenting.firstcry.com/tools/period-ovulation-calculator/'}  tabIndex={0} aria-label='calculate ovulation period'>
                                   <button className="M15_fd5387 gtm-ovulation-btn" type="button" tabIndex={-1} aria-hidden="true"> CALCULATE NOW </button>
                                   </a>
                                </div>
                           </div>   
                       </div>
                   </div>
                </div>
            </div>
        </section> : <div>
        { highlightsfeed.data.length == 0 &&
        <section className="main_container_block_feeds desktop_margin_b30">
        <div className="main_block_container_feed">
            <div className="block_container_feed_heading_text R15_61" role='heading' tabIndex={0} aria-label={highlightsfeed.dataApp[0].title}>
            {highlightsfeed.dataApp[0].title}
            </div>
            <div className="content-div-box-artical">
                <div className="fertil_background_main_view">
                    <div className="fertil_background_pic" style={{background:'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/period_ovulation_cycle1.webp'}}> 
                        <div className="ovulation_Days_calculator desktop_ovulation_Days02">
                            <div className="ovulation_Days_cal_view fc_mr_b20"> 
                                <h2 className="M15_21"> {highlightsfeed.title}</h2>
                                <div className="my_baby_question_ask"> 
                                <span className="my_baby_question_disc R16_61"> 
                                   {highlightsfeed.dataApp[0].descriptionText}
                                </span>
                                </div>
                                <a href={(highlightsfeed.dataApp)?highlightsfeed.dataApp[0].redirectionUrl:'https://parenting.firstcry.com/tools/period-ovulation-calculator/'} className="readmorelink R13_link gtm-ovulation-Readmore" tabIndex={0} aria-label='read more about ovulation calculator'> Readmore</a> 
                            </div> 
                            <div className="ovulation_fertic_btn_group_join_common fc_mr-b1">
                            <a href={(highlightsfeed.dataApp)?highlightsfeed.dataApp[0].redirectionUrl:'https://parenting.firstcry.com/tools/period-ovulation-calculator/'}  tabIndex={0} aria-label='calculate ovulation period'>
                                <button className="M15_fd5387 gtm-ovulation-btn" type="button" tabIndex={-1} aria-hidden="true"> {highlightsfeed.dataApp[0].buttonText}</button>
                                </a>
                            </div>
                        </div>   
                    </div>
                </div>
            </div>
        </div>
    </section>}</div>  
        }
    </div>
    
    )
        }
